import { Tooltip } from '../Tooltip/Tooltip';
import './view-toggle.css';

/**
 * Disabled placeholder for the 2D/3D toggle. Wired for v0.5.1 (CesiumJS) to
 * activate — this phase (v0.5.0) is 2D-only, per the plan's explicit scope
 * ("No CesiumJS ... but do add a disabled/placeholder 2D/3D toggle").
 *
 * Wrapped in a plain <span> rather than putting the hover handlers directly
 * on the <button>s: a disabled button doesn't reliably fire mouse events in
 * Chrome, which would silently break the hover card.
 */
export function ViewToggle2D3D() {
  return (
    <Tooltip heading="3D view" description="Ships in v0.5.1 with CesiumJS — not available yet.">
      <span className="view-toggle">
        <button type="button" className="view-toggle-btn active" disabled>
          2D
        </button>
        <button type="button" className="view-toggle-btn" disabled>
          3D
        </button>
      </span>
    </Tooltip>
  );
}
